/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import iconsList from 'images/svg/iconsList';

export default function Iconic({
  dataId,
  className,
  icon,
  color,
  name,
  ...rest
}) {
  const iconHandler = (svg) => {
    let tagName = 'path';
    let colorProp = 'fill';
    let strokeWidth = '';
    if (svg.includes('<polygon')) {
      tagName = 'polygon';
    } else if (svg.includes('<rect')) {
      tagName = 'rect';
    } else if (svg.includes('<circle')) {
      tagName = 'circle';
      colorProp = 'stroke';
      strokeWidth = 'stroke-width="1"';
    }
    const re = new RegExp(`<${tagName}`, 'g');
    return color
      ? svg.replace(re, `<${tagName} ${colorProp}="${color}" ${strokeWidth}`)
      : svg;
  };

  return (
    <i
      data-id={dataId}
      className={`iconic ${className}`}
      dangerouslySetInnerHTML={{
        __html: iconHandler(icon || iconsList[name] || '?'),
      }}
      {...rest}
    />
  );
}

Iconic.propTypes = {
  dataId: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.any,
  color: PropTypes.any,
  name: PropTypes.any,
};

Iconic.defaultProps = {
  dataId: '',
  className: '',
  icon: null,
  color: '',
  name: '',
};
